const STORAGE_KEY = 'admin:return_to'

export function saveReturnTo(pathname: string, search: string): void {
  sessionStorage.setItem(STORAGE_KEY, pathname + search)
}

/** Reads and clears the saved target. Only same-app paths pass the guard. */
export function takeReturnTo(): string | null {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  sessionStorage.removeItem(STORAGE_KEY)
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return null
  return raw
}
